import React, { Fragment, useRef, useState } from "react";
import {
  useLanguage,
  useAuth,
  useAuthUpdate,
} from "../context/LanguageContext";

const AccessForm = () => {
  const [checkbox, setCheckbox] = useState(false);
  let ticked = useRef();
  const currentLanguage = useLanguage();
  const auth = useAuth();
  const handleUpdate = useAuthUpdate();
  const code = useRef();

  function handleLeft(event) {
    event.preventDefault();
    code.current.value = "";
    handleUpdate("left");
    setCheckbox(false);
    ticked.current.checked = false;
  }

  function handleRight(event) {
    event.preventDefault();
    handleUpdate("right", code.current.value, checkbox);
    if (checkbox == true) {
      code.current.value = "";
    }
    setCheckbox(false);
    ticked.current.checked = false;
  }

  return (
    <Fragment>
      <form className="access-form">
        <h4 className="access-form__text">{auth[0]}</h4>
        {auth[4] !== "" && <h4 className="access-form__wrong">{auth[4]}</h4>}
        <input
          ref={code}
          className="access-form__input"
          placeholder={
            auth[3] === "get"
              ? currentLanguage.placeholder2
              : currentLanguage.placeholder1
          }
          style={auth[4] !== "" ? { border: "solid 2px #da3131" } : {}}
        />
        <div
          className="access-form__box"
          style={
            auth[3] === "get" ? { display: "block" } : { display: "none" }
          }>
          <input
            type="checkbox"
            ref={ticked}
            onChange={() => setCheckbox((prevValue) => !prevValue)}
          />{" "}
          {currentLanguage.privacyAgree}{" "}
          <a href="https://bernardompita.com/privacy-policy" target="_blank">
            <span className="access-form__privacy">
              {currentLanguage.privacyAgree2}
            </span>
          </a>
        </div>
        <div className="access-form__button__area">
          <div
            className="access-form__button access-form__button--1"
            onClick={handleLeft}>
            {auth[1]}
          </div>
          <button
            type="submit"
            className="access-form__button access-form__button--2"
            onClick={handleRight}>
            {auth[2]}
          </button>
        </div>
      </form>
    </Fragment>
  );
};

export default AccessForm;
